import { gql } from '@apollo/client';

export const NOTIFICATIONS_SUBSCRIPTION = gql`
  subscription notificationCreate($conference: String, $event: String) {
    notificationCreate(conference: $conference, event: $event) {
      callToAction
      callToActionText
      conference
      event
      id
      imageUrl
      message
      page
      status
    }
  }
`;

export const SETTINGS_SUBSCRIPTION = gql`
  subscription updateSettings($eventSlug: String) {
    updateSettings(eventSlug: $eventSlug) {
      ids
      eventSlug
    }
  }
`;
